import { startTest } from '../../test/util.js';
import './headerSimpleSpec.js';

startTest();
